import { useEffect, useState } from "react";
import { shallowObjectComparison } from "../utility/util";
import Button from "./Button";

const CancelarButton = ({ form, onReturn, wide }) => {
  const { watch, reset, getValues } = form;

  const [initialData, setInitialData] = useState(undefined);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    if (!initialData) {
      setInitialData(getValues());
    }

    const subscription = watch((values, { name, type }) => {
      let newValues = getValues();

      // O name e o type retorna como undefined quando é realizado o reset
      if (name === undefined && type === undefined) {
        setInitialData(values);
        setHasData(false);
      } else {
        setHasData(!shallowObjectComparison(newValues, initialData));
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [getValues, initialData, watch]);

  useEffect(() => {
    setHasData(!shallowObjectComparison(getValues(), initialData));
  }, [getValues, initialData]);

  if (hasData) {
    return (
      <Button
        className={`${wide ? "!w-[181px]" : undefined}`}
        type="button"
        onClick={() => {
          reset();
          onReturn?.();
        }}
      >
        Cancelar
      </Button>
    );
  }

  return (
    <Button
      className={`${wide ? "!w-[181px]" : undefined}`}
      type="button"
      onClick={() => onReturn?.()}
    >
      Voltar
    </Button>
  );
};

export default CancelarButton;
